import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const OrangeLockIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="50" height="50" viewBox="0 0 512 512">
		<g transform="translate(-2.5 -2.5)">
			<circle cx="256" cy="256" r="256" transform="translate(2.5 2.5)" fill="#fa9900" opacity="0.15" />
			<g transform="translate(137.038 115.598)">
				<path
					d="M181.921,6.717a60.345,60.345,0,0,1,61,59.645h0V136.91a60.345,60.345,0,0,1-61,59.659H61A60.345,60.345,0,0,1,0,136.91H0V66.362A60.345,60.345,0,0,1,61,6.717ZM121.39,73.45A12.5,12.5,0,0,0,108.758,85.81h0v31.523a12.7,12.7,0,1,0,25.407,0h0V85.81A12.532,12.532,0,0,0,121.39,73.45Z"
					transform="translate(0 89.231)"
					fill="#fa9900"
					opacity="0.8"
				/>
				<path
					d="M160.807,77.171V98.134A59.345,59.345,0,0,0,144.831,96H135.4V77.171a53.529,53.529,0,0,0-107.015-.286V96H19.1A54.543,54.543,0,0,0,2.978,98.277V77.171A78.121,78.121,0,0,1,81.671.007a78.036,78.036,0,0,1,79.136,77.164"
					transform="translate(39.576 0.001)"
					fill="#fa9900"
					opacity="0.4"
				/>
			</g>
		</g>
	</svg>
);
